import { FC } from 'react';
import styled from 'styled-components';
import delete_icon from '../../../../assets/delete_icon.svg';
import home_icon from '../../../../assets/home_icon.svg';
import bed_icon from '../../../../assets/bed_icon.svg';
import start_icon from '../../../../assets/start_icon.svg';
import arrow_right_icon from '../../../../assets/arrow_right_icon.svg';
import { IHotel } from '../../../../store/hotel/interface';
import { useNavigate } from 'react-router-dom';
import { Carousel } from '../../../../component/carousel';
import { pxToRem } from '../../../../utils/pxToRem';

type IHotelListCard = {
  handleDelete: () => void;
  hotel: IHotel;
};

export const HotelListCard: FC<IHotelListCard> = ({ hotel, handleDelete }) => {
  const navigate = useNavigate();
  const handleView = () => {
    navigate(`/hotel/view/${hotel.name}/${hotel._id}`, {
      state: { hotelId: hotel._id }
    });
  };
  return (
    <Card>
      <Carousel images={hotel.file} />
      <DeleteBtn onClick={handleDelete}>
        <Icon src={delete_icon} />
      </DeleteBtn>
      <HotelDetails>
        <HotelName>{hotel.name}</HotelName>
        <IconRow>
          <IconGroup icon={home_icon} text={hotel.type.replace('-', ' ')} />
          <IconGroup
            icon={start_icon}
            text={
              hotel.rating.includes('AAA')
                ? hotel.rating
                : `${hotel.rating} star`
            }
          />
          <IconGroup icon={bed_icon} text={`${hotel.noOfRooms} rooms`} />
        </IconRow>
        <HotelDescription>{hotel.description}</HotelDescription>
        <ViewBtn onClick={handleView}>
          <p>View</p>
          <Icon src={arrow_right_icon} />
        </ViewBtn>
      </HotelDetails>
    </Card>
  );
};

const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  position: relative;
  padding: 8px 8px 35px 8px;
  width: calc(30.33% - 16px);
  max-height: 498px;
  margin: 0px 10px;
  margin-bottom: 48px;
  @media (max-width: 1000px) {
    width: calc(45% - 16px);
    margin: 0px 15px;
    margin-bottom: 48px;
  }
  @media (max-width: 730px) {
    width: 100%;
    margin: 0;
    margin-bottom: 48px;
  }
`;
const DeleteBtn = styled.button`
  position: absolute;
  right: 24px;
  top: 16px;
  background-color: transparent;
  outline: none;
  border: none;
  padding: 0;
  & :hover {
    opacity: 0.6;
  }
`;
const Icon = styled.img`
  max-height: 48px;
  max-width: 48px;
`;

const HotelDetails = styled.div`
  padding: 23px 16px 0px 16px;
`;
const HotelName = styled.p`
  font-size: ${pxToRem(16)};
  font-style: normal;
  font-weight: 500;
  line-height: ${pxToRem(22)};
  letter-spacing: 0px;
  text-align: left;
  margin-bottom: 16px;
`;
const IconRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;
const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const IconTitle = styled.p`
  font-size: ${pxToRem(12)};
  font-style: normal;
  max-width: 120px;
  font-weight: 400;
  line-height: ${pxToRem(14)};
  letter-spacing: 0px;
  text-align: center;
  margin-top: 8px;
  text-transform: capitalize;
`;
const HotelDescription = styled(HotelName)`
  font-size: ${pxToRem(14)};
  font-weight: 400;
  flex: 1;
  height: 66px;
  overflow: hidden;
  align-self: stretch;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

const ViewBtn = styled.button`
  font-style: normal;
  font-weight: 500;
  font-size: ${pxToRem(12)};
  line-height: 150%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  padding: 7px 12px;
  outline: none;
  border: none;
  padding: 0;
  color: ${({ theme }) => theme.colors.sojiOrange};
  & :hover {
    opacity: 0.6;
  }
`;

export const IconGroup: FC<{ icon: string; text: string }> = ({
  icon,
  text
}) => {
  return (
    <IconContainer>
      <Icon src={icon} />
      <IconTitle>{text}</IconTitle>
    </IconContainer>
  );
};
